export const HEADER_HEIGHT = 90
export const MAIN_LAYOUT_ID = 'mainLayoutScroll'
export const CONTACT_US_FORM = 'contactForm'
export const LEFT_MENU_WIDTH = "280px";
export const MOBILE_WIDTH = "640px";
